import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, stagger, item } from "@/lib/motion";
import { SERVICES_TEASER } from "@/data/site";

export const ServicesTeaser = () => (
  <section data-testid="services-teaser" className="section-pad bg-[#F5F5F5]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#999999] mb-6 font-mono">What we do</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-3xl text-[#111111]">
          Your Full Growth Engine.
        </h2>
      </Reveal>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#E0E0E0]"
      >
        {SERVICES_TEASER.map((s) => (
          <motion.div key={s.n} variants={item}>
            <Link
              to={`/services#${s.anchor}`}
              data-testid={`teaser-card-${s.anchor}`}
              className="group relative block h-full p-8 md:p-10 border-r border-b border-[#E0E0E0] bg-[#F5F5F5] hover:bg-[#111111] transition-colors duration-300"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-[#999999] group-hover:text-[#666666]">{s.n}</span>
                <ArrowUpRight
                  size={20}
                  className="text-[#999999] group-hover:text-white transition-all group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
              <h3 className="mt-8 font-serif text-2xl md:text-[1.7rem] leading-tight text-[#111111] group-hover:text-white transition-colors">
                {s.title}
              </h3>
              <p className="mt-4 text-[#666666] group-hover:text-[#E0E0E0] transition-colors leading-relaxed">
                {s.line}
              </p>
            </Link>
          </motion.div>
        ))}
      </motion.div>

      <Reveal delay={0.1}>
        <Link
          to="/services"
          data-testid="teaser-view-all"
          className="inline-flex items-center gap-2 mt-12 bg-[#111111] text-white font-semibold px-8 py-4 hover:bg-[#333333] transition-colors group"
        >
          View All Services
          <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);
